import { AdvancedMultibuys } from './advanced-multibuys.js';
import setViewportHeight from './set-dimensions-variables.js';
import './cart-actions.js';

(() => {
  var customerId = document.querySelector('[data-customer-id').dataset.customerId;
  var petfixCookie = document.cookie.match(/^(.*;)?\s*Petfix\s*=\s*[^;]+(.*)?$/);
  var petfixAdditional = document.cookie.match(/^(.*;)?\s*PetfixAdditional\s*=\s*[^;]+(.*)?$/);

  if (customerId && petfixCookie != null && petfixAdditional != null) {
    var params = JSON.stringify({
      customer_id: customerId,
      channel_code: 'default',
      channel: 'default'
    });
    fetch('https://petstop.lerp.sf9dev.com/petstop/proxy/addcustomerpetfixtag', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      mode: 'cors',
      body: params
    }).then(response => {
      if (response.ok === true) {
        document.cookie = 'PetfixAdditional=; expires=01 Jan 1970 00:00:00 UTC; path=/;';
      }
    }).catch(error => console.error(`${error}`));
  }

  if (Shopify.theme.settings.enable_promotion_advanced_multibuy) {
    AdvancedMultibuys.init();

    if (window.location.href.includes('/cart')) {
      document.dispatchEvent(new CustomEvent('cart:updated'));
    }
  }

  function debounce(fn, wait = 300) {
    let t;
    return (...args) => {
      clearTimeout(t);
      t = setTimeout(() => fn.apply(this, args), wait);
    };
  }

  setViewportHeight.setHeightInit();
  window.addEventListener('resize', debounce(setViewportHeight.setHeightInit, 50));
})();
